import request from "@/utils/request"


// 获取模板列表
export const getTemplates = function(query = {}) {
  return request('get', '/api/tag/list', query)
}

// 获取模板详情
export const getTemplateDetail = function(id) {
  return request('get', '/api/tag/detail', { id })
}

// 获取模板可选项（当前租户）
export const getTemplateOptions = function(query = {}) {
  return request('get', '/api/common/getTag', query)
}
